import React from "react";
import styled from "styled-components";
import { Colors, TextFont, Text } from "../../../config";
const microsoftLogo = require("../../../assets/images/Microsoft_logo.png");

const MicrosoftImageAndTitle = () => {
  return (
    <ImgTagWrapper>
      <img src={microsoftLogo} alt="Microsoft_logo" />
      <TextFont fontColor={Colors.white} fontWeight="400">
        {Text.pihEmployeesWithEmail}
      </TextFont>
    </ImgTagWrapper>
  );
};

export default MicrosoftImageAndTitle;

const ImgTagWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
  padding-bottom: 2rem;
`;
